export default {
    getUserFacilities: (state) => {
        return state.user_facilities;
    },
};
